import type { Candle, MarketHistory } from '../../../../packages/sdk/src';

// Deliberately fictional, fixed-time chart exercise. Never used by quotes or balances.
const end = Date.UTC(2026, 8, 26, 12);
const minute = 60_000;
const candles: Candle[] = Array.from({ length: 1440 }, (_, i) => {
  const price = (n: number) => 0.000014 + n * 0.000000012 + Math.sin(n / 23) * 0.0000018 + Math.sin(n / 5) * 0.00000035;
  const open = price(i), close = price(i + 1);
  return { time: end - (1440 - i) * minute, open: String(open), close: String(close), high: String(Math.max(open, close) + 0.0000003), low: String(Math.min(open, close) - 0.0000002), volume: String(BigInt(1 + i % 9) * 10n ** 22n), trades: 1 };
});

export function exampleNearHistory(range: string, requestedInterval: number): MarketHistory {
  const interval = Math.max(minute, requestedInterval);
  const source = range === '1H' ? candles.slice(-60) : candles;
  const grouped: Candle[] = [];
  for (const row of source) {
    const time = Math.floor(row.time / interval) * interval;
    const last = grouped.at(-1);
    if (last?.time === time) {
      last.close = row.close;
      last.high = String(Math.max(Number(last.high), Number(row.high)));
      last.low = String(Math.min(Number(last.low), Number(row.low)));
      last.volume = String(BigInt(last.volume) + BigInt(row.volume));
      last.trades += row.trades;
    } else grouped.push({ ...row, time });
  }
  return { candles: grouped, interval, quoteSymbol: 'NEAR', quoteDecimals: 24, from: source[0].time, to: end, indexedAt: null, lastTradeAt: null, complete: false, priceBasis: 'Simulated chart exercise. Fictional prices and volume; not OVTEST executions, a valuation, backing or a quote. One day of sample data; minimum resolution one minute.' };
}
